<div class="utenti-container">
  <!-- Header della pagina -->
  <div class="utenti-header">
    <div class="title-container">
      <span class="material-icons" style="vertical-align: middle; margin-right: 8px; font-size: 28px; color: #166F72;">people</span>
      <h1 class="page-title">{{ titoloUtenti }}</h1>
      <span *ngIf="filtriAttivi" class="filter-badge">Filtri attivi</span>
      <button *ngIf="filtriAttivi"
        pButton type="button" icon="pi pi-filter-slash"
        class="p-button-rounded p-button-text p-button-danger"
        (click)="pulisciFiltroGlobale()"
        pTooltip="Rimuovi tutti i filtri" tooltipPosition="top">
      </button>
    </div>

    <div class="actions-container">
      <div class="search-container">
        <div class="custom-search-input">
          <i class="pi pi-search search-icon" [ngClass]="{'hidden': filtroTestoGlobale.length > 0}"></i>
          <input
            type="text"
            pInputText
            [(ngModel)]="filtroTestoGlobale"
            (input)="onFiltroGlobaleChange($event)"
            placeholder="Cerca"
            class="search-input"
          />
          <i class="pi pi-times clear-icon" *ngIf="filtroTestoGlobale.length > 0" (click)="pulisciFiltroGlobale()" style="cursor: pointer;"></i>
        </div>
      </div>

      <button class="action-button"
          style="background-color: #a0cccc; color: #333; border: 1px solid #A0D6C1; box-shadow: 0 2px 4px rgba(0,0,0,0.1); border-radius: 6px;"
              (click)="modificaUtente(null)">
            <span class="material-icons" style="margin-right: 8px;">add</span>
            Nuovo utente
      </button>
      <button [disabled]="!utentiCaricati" class="action-button" (click)="caricaUtenti()"
              style="background-color: #C7CEEA; color: #333; border: 1px solid #B2BCDC; box-shadow: 0 2px 4px rgba(0,0,0,0.1); border-radius: 6px; cursor: pointer;">
        <span class="material-icons" style="margin-right: 8px;">refresh</span>
        Aggiorna
      </button>
    </div>
  </div>

  <div class="utenti-content">
    <!-- Loader mentre vengono caricati gli utenti -->
    <div *ngIf="!utentiCaricati" class="loading-container">
      <div class="spinner"></div>
      <p>Caricamento utenti in corso...</p>
    </div>

    <!-- Lista degli utenti con p-table -->
    <div *ngIf="utentiCaricati" class="utenti-list">
      <!-- Messaggio se non ci sono utenti -->
      <div *ngIf="utenti.length === 0" class="empty-state">
        <span class="material-icons">search_off</span>
        <h3>Nessun utente trovato</h3>
      </div>

      <!-- PrimeNG Table -->
      <p-table
        *ngIf="utenti.length > 0"
        #dt
        [value]="utenti"
        [columns]="cols"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10,50,100,200]"
        styleClass="p-datatable-sm p-datatable-gridlines"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Utenti da {first} a {last} di {totalRecords}"
        [globalFilterFields]="['nome', 'email', 'ruolo.descrizione', 'enteEsecutore.label']"
        [sortField]="'nome'" [sortOrder]="1"
        responsiveLayout="stack"
        [rowHover]="true">

        <!-- Intestazioni delle colonne -->
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 5%;" style="font-size: 14px;">Azioni</th>
            <th *ngFor="let col of cols" [pSortableColumn]="col.field" [style.width]="col.width" style="font-size: 14px;">
              {{ col.header }}
             <!--  <p-sortIcon *ngIf="col.sortable" field="col.field"></p-sortIcon> -->
            </th>

          </tr>
        </ng-template>

        <!-- Corpo della tabella -->
        <ng-template pTemplate="body" let-utente>
          <tr>
            <td>
              <div class="p-d-flex p-jc-center">
                <button pButton icon="pi pi-ellipsis-v" class="p-button-rounded p-button-text"
                  (click)="openAzioni($event, utente)" pTooltip="Azioni" tooltipPosition="top"></button>
              </div>
            </td>
            <td>
              <span style="display: block; text-align: left; font-size: 12px; font-weight: 600; font-weight: bold;">{{ utente.nome | uppercase}}</span>
            </td>
            <td>
              <span style="display: block; text-align: left; font-size: 12px;">{{ utente.email }}</span>
            </td>
            <td>
              <div class="ruolo-badge" [ngClass]="'ruolo-badge-' + utente.ruolo?.codice" style="margin: 0">
                <span class="ruolo-value">{{ utente.ruolo?.descrizione | uppercase }}</span>
              </div>
            </td>
            <td>
              <div class="ente-badge" [ngClass]="'ente-badge-' + utente.enteEsecutore?.categoria?.descrizione.toLowerCase()" style="margin: 0">
                <span class="ente-value">{{ utente.enteEsecutore?.label | uppercase }}</span>
              </div>
            </td>
          </tr>
        </ng-template>

        <!-- Footer della tabella -->
        <ng-template pTemplate="paginatorleft">
        </ng-template>

        <ng-template pTemplate="paginatorright">
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- Toast per notifiche -->
<p-toast position="top-right"></p-toast>
<p-tieredMenu #menuAzioniTiered [popup]="true" [model]="menuAzioniItems"></p-tieredMenu>

<!-- Componente per la modifica/creazione utente -->
<app-modifica-utente
  [(visible)]="mostraModificaUtente"
  [utente]="utenteSelezionato!"
  (utenteModificato)="onUtenteModificato($event)">
</app-modifica-utente>

<p-dialog
  [(visible)]="mostraConfermaEliminazione"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [style]="{width: '450px'}"
  styleClass="p-fluid conferma-eliminazione-dialog"
  [showHeader]="false"
  (onHide)="mostraConfermaEliminazione = false">

  <div class="dialog-container">
    <div class="dialog-header">
      <div class="header-content">
        <i class="pi pi-trash header-icon"></i>
        <h2>Conferma Eliminazione</h2>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        (click)="mostraConfermaEliminazione = false">
      </button>
    </div>

    <div class="dialog-content">
      <div class="confirmation-content text-center">
        <div class="flex justify-content-center mb-3">
          <i class="pi pi-exclamation-triangle" style="font-size: 2rem; color: #f44336;"></i>
        </div>
        <span class="confirmation-message text-center" style="display: block;">
          Sei sicuro di voler eliminare l'utente {{ utenteDaEliminare?.nome }}?
          <br>
          Questa azione non può essere annullata.
        </span>
      </div>
    </div>

    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        (click)="mostraConfermaEliminazione = false">
      </button>
      <button
        pButton
        pRipple
        label="Elimina"
        icon="pi pi-trash"
        class="p-button-danger"
        (click)="confermaEliminazione()">
      </button>
    </div>
  </div>
</p-dialog>
